// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2ZZFQ","info":"UpdateTermsInfo_info__211lY"};